var _mask, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 62,
    viewBox: "0 0 113 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_840_6560",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.239258,
    y: 29.2539,
    width: 112.109,
    height: 12.0732,
    rx: 2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.239258,
    y: 29.2539,
    width: 112.109,
    height: 12.0732,
    rx: 2,
    fill: "#CEECB5",
    stroke: "black",
    strokeWidth: 6,
    mask: "url(#path-1-inside-1_840_6560)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3491 2.2959C22.0107 2.2959 25.1847 4.83043 25.9949 8.40129L30.3448 27.5743C30.5457 28.4598 30.6471 29.3651 30.6471 30.2732L30.6471 54.162C30.6471 57.1996 28.1847 59.662 25.1471 59.662L11.5512 59.662C8.51359 59.662 6.05115 57.1996 6.05115 54.162L6.05116 30.2732C6.05116 29.3651 6.15256 28.4598 6.35348 27.5743L10.7034 8.40129C11.5135 4.83043 14.6875 2.2959 18.3491 2.2959Z",
    fill: "#CEECB5",
    stroke: "black",
    strokeWidth: 3
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHammer);
export default __webpack_public_path__ + "static/media/hammer.ed31761c5705aaf9320f29ebb5c4c53b.svg";
export { ForwardRef as ReactComponent };